import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface LabelPolicyUser {
  id: number;
  identifier: string;
  mail: string;
  directivas: string;
  etiquetas: string;
  numDirectivas: number;
  fuenteAsignacion: string;
  grupos: string;
  lastSynced: string;
}

export interface PagedResult<T> {
  total: number;
  page: number;
  pageSize: number;
  results: T[];
}

export interface LabelPolicyOptions {
  directivas: string[];
  etiquetas: string[];
}

export interface DirectivaStat {
  nombre: string;
  usuarios: number;
}

export interface LabelPolicyStats {
  totalUsuarios: number;
  usuariosMultiDirectiva: number;
  directivasActivas: DirectivaStat[];
}

@Injectable({ providedIn: 'root' })
export class LabelPolicyService {
  private baseUrl = environment.apiUrl + 'LabelPolicy/';

  constructor(private http: HttpClient) {}

  getUsers(
    idCompany: number,
    filters: { identifier?: string; directivas?: string[]; fuenteAsignacion?: string; etiquetas?: string[] },
    page: number,
    pageSize: number,
    sortBy: string = 'identifier',
    sortDir: string = 'asc'
  ): Observable<HttpResponse<PagedResult<LabelPolicyUser>>> {
    let params = new HttpParams()
      .set('idCompany', idCompany.toString())
      .set('pg', page.toString())
      .set('pageSize', pageSize.toString())
      .set('sortBy', sortBy)
      .set('sortDir', sortDir);

    if (filters.identifier) params = params.set('identifier', filters.identifier);
    if (filters.fuenteAsignacion) params = params.set('fuenteAsignacion', filters.fuenteAsignacion);
    if (filters.directivas?.length) {
      filters.directivas.forEach(d => { params = params.append('directivas', d); });
    }
    if (filters.etiquetas?.length) {
      filters.etiquetas.forEach(e => { params = params.append('etiquetas', e); });
    }

    return this.http.get<PagedResult<LabelPolicyUser>>(this.baseUrl + 'users', {
      observe: 'response',
      params,
    });
  }

  getOptions(idCompany: number): Observable<HttpResponse<LabelPolicyOptions>> {
    return this.http.get<LabelPolicyOptions>(this.baseUrl + 'options', {
      observe: 'response',
      params: { idCompany: idCompany.toString() },
    });
  }

  getStats(idCompany: number): Observable<HttpResponse<LabelPolicyStats>> {
    return this.http.get<LabelPolicyStats>(this.baseUrl + 'stats', {
      observe: 'response',
      params: { idCompany: idCompany.toString() },
    });
  }

  exportExcel(
    idCompany: number,
    filters: { identifier?: string; directivas?: string[]; fuenteAsignacion?: string; etiquetas?: string[] },
    culture: string = 'es'
  ): Observable<HttpResponse<Blob>> {
    let params = new HttpParams().set('idCompany', idCompany.toString()).set('culture', culture);
    if (filters.identifier) params = params.set('identifier', filters.identifier);
    if (filters.fuenteAsignacion) params = params.set('fuenteAsignacion', filters.fuenteAsignacion);
    if (filters.directivas?.length) {
      filters.directivas.forEach(d => { params = params.append('directivas', d); });
    }
    if (filters.etiquetas?.length) {
      filters.etiquetas.forEach(e => { params = params.append('etiquetas', e); });
    }
    return this.http.get(this.baseUrl + 'export', {
      observe: 'response',
      responseType: 'blob',
      params,
    });
  }
}
